module.exports = __webpack_public_path__ + "img/example3.243027f1.png";